/**
 * 购买前的检查
 *  1、检查是类型，如果是非coins和vip，则需要等待登录
 *  2、如果是通过coins购买，则检查当前金币是否充足
 *  3、如果购买的是post类型的，需检查是否有po
 *  4、如果是通过coins购买，并且是大额购买，则弹窗提示
 *  5、如果是私有账号，设为公有
 *  6、如果购买comment不能评论，设为可以评论
 */

import * as checkUtil from "./payment_check_helper";
import {
  isFollow,
  OfferKind,
  PayAnyParams,
  PaymentWithSituationParams,
  SkuClickCategory
} from "@/services/offer/offer_handle";
import { isVipOrCoins } from "@/utils/general_utils";
import paymentCall from "@/services/payment/paymentCall";
import { store, Vue } from "@/main";
import { GETTER_CURRENT_INS_USER_INFO, SHOW_SEARCH_OR_LOGIN } from "@/store/constants/ins_user_info_types";
import {
  coinsNotEnoughDialog,
  largePurchaseConfirm,
  showPrivateDialog,
  turnOnCommentImmediateDialog,
  turnOnCommentToInstagram
} from "./payment_check_dialog";
import { skuClickEvent } from "@/utils/log_event/purchase_event";
import { LoginFromTypes } from "@/utils/router_helper/types";

const paymentCheckGenerator = async function* PaymentCheck(params: PaymentWithSituationParams) {
  const {offer} = params;
  // 如果不是vip或者coins类型，需要往下校验
  if (!isVipOrCoins(offer)) {
    // 判断有没有登录，如果没有登录，出登录弹窗
    if (!checkUtil.hasUser()) {
      skuClickEvent({ ...params, result: SkuClickCategory.login_required });
      yield store.dispatch(SHOW_SEARCH_OR_LOGIN, LoginFromTypes.BUY);
    }

    // 如果是私有账号
    if (checkUtil.isPrivateUser()) {
      const currentUserInfo = store.getters[GETTER_CURRENT_INS_USER_INFO];
      yield showPrivateDialog({
        ...params,
        type: currentUserInfo.user_type
      },
        isFollow(offer.kind)
      );
    }
    // 判断是否可以评论
    const { comments_disabled, user_type } = checkUtil.isPostCommentDisabled(offer)
    if (comments_disabled) {
      if (user_type === "login") {
        yield turnOnCommentImmediateDialog(params);
      } else {
        skuClickEvent({ ...params, result: SkuClickCategory.comment_disable });
        yield turnOnCommentToInstagram();
      }
    }
    // 如果买like和comment没有post
    if (checkUtil.buyLikeOrCommentWithoutPost(offer)) {
      skuClickEvent({ ...params, result: SkuClickCategory.need_post });
      Vue.prototype.$_Toast.show({
        duration: 3000,
        type: "warning",
        text: `No post yet!`
      });
      return;
    }
    // 没有view的情况下买video
    if (checkUtil.buyViewWithoutVideo(offer)) {
      Vue.prototype.$_Toast.show({
        duration: 3000,
        type: "warning",
        text: `Choose a video first!`
      });
      return;
    }
    // 如果金币不够，出金币不够弹窗
    if (checkUtil.lackCoins(offer)) {
      yield coinsNotEnoughDialog(params);
    }
    // 如果是大额购买
    if (checkUtil.isLargePurchase(offer)) {
      yield largePurchaseConfirm(params);
    }
  }
  paymentCall.payAny(params);
}

class PaymentCheckModule {
  private generator: any;

  public init(params: PayAnyParams) {
    this.generator = paymentCheckGenerator(params);
  }

  public get() {
    return this.generator;
  }
}

export default new PaymentCheckModule();
